"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var makeStyle = function makeStyle() {
  return {
    InfoBox: {
      backgroundColor: '#FFFAE7',
      border: '3px solid #EEC855',
      borderRadius: 6,
      padding: [7, 10],
      "float": 'left',
      width: '100%',
      marginBottom: 10
    }
  };
};

var _default = makeStyle;
exports["default"] = _default;
//# sourceMappingURL=style.js.map